document.addEventListener( 'DOMContentLoaded', () => {

  const caregiver = document.querySelectorAll( '[class*="caregiver-perspectives"]' )
  const perspectives = document.querySelectorAll( '[class*="pnh-perspectives"]' )
  console.log( caregiver, perspectives )

  if ( ! caregiver.length && ! perspectives.length ) return false

  const postType = perspectives.length ? 'perspective' : 'care-perspective'

  /**
   * The route we're using to manage all filtering logic.
   *
   * @type {string}
   */
  const route = `https://${window.location.hostname}/wp-content/themes/Volum8WP/assets/functions/inc/Perspectives.php`

  /**
   * Set a window property to keep track of the current page.
   *
   * @type {number}
   */
  window.currentPage = 1

  /**
   * An array that represents the selected filters
   * in `term_slug_term->id` format.
   *
   * @type {string[]}
   */
  let selectedFilters = []

  /**
   * A variable that represents the current sort by filter.
   *
   * @type {string|null}
   */
  let selectedSortFilter = null

  /**
   * A collection of load more buttons.
   *
   * @type {NodeListOf<Element>}
   */
  const loadMoreButtons = document.querySelectorAll( '[data-load-more]' )

  /**
   * The parent load more container.
   *
   * @type {Element|null}
   */
  const loadMoreContainer = document.querySelector( '[data-load-more-container]' )

  /**
   * The loading spinner.
   *
   * @type {Element|null}
   */
  const loader = document.querySelector( '.loading-data.loader' )

  /**
   * The main form element for the filters.
   *
   * @type {HTMLFormElement|null}
   */
  const filterForm = document.querySelector( '#filter-perspectives-form' )

  /**
   * The main accordion trigger button.
   *
   * @type {HTMLButtonElement|null}
   */
  const filterTrigger = document.getElementById( 'acc_1-1_panel_1_trigger' )

  /**
   * Reset the form and its filters.
   */
  const resetFilters = () => {
    filterForm.reset()
    window.currentPage = 1
    selectedFilters = []
    selectedSortFilter = null
  }

  /**
   * Reset the form on first load.
   */
  filterForm.reset()

  /**
   * Get all reset buttons and set up resets when they're clicked.
   *
   * @return {void}
   */
  const setupClear = () => {
    const resetButtons = document.querySelectorAll( 'input[type="reset"], #reset-filters-filter' )
    resetButtons?.forEach( reset => reset.addEventListener( 'click', () => resetFilters() ) )
  }

  /**
   * The main function to get results.
   *
   * @param {number} page The paginated results number.
   * @param {boolean} loadMore Whether it's for loading more content.
   */
  const getResults = async ( page, loadMore = false ) => {

    /**
     * Show the loader whenever we're loading content.
     */
    loader.style.display = 'block'

    /**
     * Hide the results if we're not loading more.
     */
    if ( ! loadMore ) loadMoreContainer.style.display = 'none'

    /**
     * Get the response.
     *
     * @type {Promise<Response>} The server response containing HTML content.
     */
    const response = await fetch( route,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {
            postType: postType,
            filters: selectedFilters,
            order: selectedSortFilter,
            page: page
          }
        )
      }
    )

    /**
     * Convert the response to a string.
     *
     * @type {string}
     */
    const text = await response.text()

    if ( loadMore ) {

      /**
       * If we're loading more, add it to the container.
       */
      loadMoreContainer.insertAdjacentHTML( 'beforeend', text )

    } else {

      /**
       * TODO: Add the filter to history.
       */
      // const url = new URL( window.location )
      // url.searchParams.set( 'filters', `[${selectedFilters.join( '|' )}]` )
      // window.history.pushState( {}, '', url )

      /**
       * If it's a new request, replace the content.
       */
      loadMoreContainer.innerHTML = text

    }

    /**
     * Check if we need to hide the load more button.
     */
    checkPages( response )

    /**
     * Check for new buttons and set up their listeners.
     */
    setupClear()

    /**
     * Hide the loader.
     */
    loader.style.display = 'none'

    /**
     * Show the results.
     */
    loadMoreContainer.style.display = 'flex'

    // Reinitialize player elements for new elements. See plyr-init.js.
    initializePlayers() // eslint-disable-line no-undef

    // Reinitialize copy buttons for new elements. See perspectives.js.
    handleCopyLinks() // eslint-disable-line no-undef

    // Close the filter if it's open.
    if ( filterTrigger.ariaExpanded === 'true' ) filterTrigger.click()

  }

  /**
   * Handle hiding/showing the load more button.
   *
   * @param {Promise<Response>} response The response from the server.
   * @returns {boolean} True if there are more pages, false if not.
   */
  const checkPages = ( response ) => {
    if ( response.headers.get( 'x-last-page' ) ) {
      loadMoreButtons.forEach( loadMoreButton => loadMoreButton.style.display = 'none' )
      return false
    }
    window.currentPage += 1
    loadMoreButtons.forEach( loadMoreButton => loadMoreButton.style.display = 'flex' )
    return true
  }

  /**
   * Get the first page of results when the filter button is clicked.
   */
  filterForm.addEventListener( 'submit', async ( event ) => {
    event.preventDefault()
    window.currentPage = 1
    await getResults( window.currentPage )
  } )

  /**
   * Setup the listeners for the loadMoreButtons.
   */
  loadMoreButtons.forEach( loadMoreButton => loadMoreButton.addEventListener( 'click', () => getResults( window.currentPage, true ) ) )

  /**
   * Check the filters dynamically as they're edited.
   *
   * @return {void}
   */
  const checkFilters = () => {

    /**
     * Get the filters that are checkboxes.
     *
     * @type {NodeListOf<Element>} A collection of checkbox inputs.
     */
    const filters = document.querySelectorAll( '.filters input[type="checkbox"]' )

    /**
     * Keep selected filters in sync with what's checked on the page.
     */
    filters.forEach( filter => filter.addEventListener( 'change', ( e ) =>
      selectedFilters = e.target.checked
      ? selectedFilters.concat( [ e.target.id ] )
      : selectedFilters.filter( selectedFilter => selectedFilter !== e.target.id )
    ) )

    /**
     * Get the filters that are radio buttons.
     *
     * @type {NodeListOf<Element>} A collection of radio button inputs.
     */
    const sortFilters = document.querySelectorAll( '.filters input[type="radio"]' )

    /**
     * Since only one filter can be clicked at one time,
     * set it to the one that's clicked every time.
     */
    sortFilters.forEach( sortFilter => sortFilter.addEventListener( 'change', ( e ) => selectedSortFilter = e.target.checked ? e.target.value : null ) )
  }

  /**
   * Check the filters on page load.
   */
  checkFilters()

  /**
   * Get initial results on page load.
   */
  getResults( window.currentPage )

} )
